import { EVENT_CODE } from '@constants'

import { ActionRow } from '../../../types'

export const findActionByEventCode = (eventCode: EVENT_CODE, actions: ActionRow[] | undefined) => {
  return actions?.find(action => action.eventCode === eventCode)
}
